// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"95796b81","185":"56d41ca9","414":"dfbbe99b","453":"c1ac9919","521":"f94b1fe7","629":"d1c3d34f","825":"2d2bfe07","896":"1c3c7616"}[chunkId] + ".chunk.js";
};